import { QueryClient } from '@tanstack/react-query';
import {
  GlobalPermission,
  SystemPermission_Permission,
} from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/user_pb';
import { LoaderFunctionArgs } from 'react-router';
import { System } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/system_pb';
import { getSystemQuery } from '~/shared/api/system.queries';
import {
  requireUserGlobalPermission,
  requireUserPermissionForSystemId,
} from '~/shared/auth/auth-utils';
import { assertIsDefined } from '~/types/assert-type';
import { listSystemSimulationsQuery } from '~/pages/SystemSimulationsPage/api/systemSimulations.queries';
import { SystemSimulationsListModel } from '~/pages/SystemSimulationsPage/models/SystemSimulationsListModel';
import { ResourceNameIdConverter } from '~/shared/models/ResourceNameIdConverter';

export type SystemSimulationsLoaderData = {
  simulations: SystemSimulationsListModel;
  system: System;
};

export const systemSimulationsPageLoader =
  (queryClient: QueryClient) =>
  async ({
    params,
    request,
  }: LoaderFunctionArgs): Promise<SystemSimulationsLoaderData | Response> => {
    const { systemId } = params;

    assertIsDefined(systemId);

    await requireUserGlobalPermission(
      queryClient,
      request,
      GlobalPermission.WAVIN_ONLY,
    );

    await requireUserPermissionForSystemId(
      queryClient,
      request,
      SystemPermission_Permission.VIEWER,
      systemId,
    );

    const [simulations, system] = await Promise.all([
      queryClient.ensureQueryData(
        listSystemSimulationsQuery({
          systemName: ResourceNameIdConverter.systemIdToName(systemId),
        }),
      ),
      queryClient.ensureQueryData(getSystemQuery(systemId)),
    ]);

    return {
      simulations,
      system,
    };
  };
